class LinkBlock {
    constructor() {
        const blocks = [...document.querySelectorAll('.link-block--limit')];
        const header = document.querySelector('.headroom-wrapper');

        blocks.map((block) => {
            const limit = parseInt(block.dataset.limit);
            const button = block.querySelector('button');
            this.toggleLinks(block, limit, button, header, true);
            button.addEventListener('click', () => { this.toggleLinks(block, limit, button, header, false); })
        });
    }

    toggleLinks(block, limit, button, header, isInitialize) {
        const SHOW_MORE_TEXT = 'Visa fler';
        const SHOW_LESS_TEXT = 'Visa färre';

        if (!isInitialize) {
            button.classList.toggle('button-new--collapse');
            button.classList.toggle('button-new--expand');
        }

        const links = [...block.querySelectorAll('ul li')];
        const buttonTextElement = button.querySelector('span');

        for (let i = 0; i < links.length; i++) {
            if (i > limit - 1) {
                const link = links[i];
                link.classList.toggle('link-block__list-item--hidden');
            }
        }

        if (buttonTextElement.innerHTML === SHOW_MORE_TEXT) {
            buttonTextElement.innerHTML = SHOW_LESS_TEXT;
            block.classList.add('link-block--expanded');
        }
        else {
            buttonTextElement.innerHTML = SHOW_MORE_TEXT;
            block.classList.remove('link-block--expanded');
            if (!isInitialize) {
                window.setTimeout(() => {
                    window.scroll({
                        top: (block.offsetTop - header.clientHeight),
                        behavior: 'smooth'
                    });
                }, 50);
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new LinkBlock();
});